import React from 'react';
import { Paper, Typography, Box } from '@mui/material';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from 'recharts';

interface TrendData {
  month: string;
  attendance: number;
  interventions: number;
  successRate: number;
}

const mockTrendData: TrendData[] = [
  { month: 'Jan', attendance: 92, interventions: 15, successRate: 85 },
  { month: 'Feb', attendance: 94, interventions: 18, successRate: 88 },
  { month: 'Mar', attendance: 93, interventions: 20, successRate: 87 },
  { month: 'Apr', attendance: 95, interventions: 16, successRate: 90 },
  { month: 'May', attendance: 96, interventions: 14, successRate: 92 }
];

export const TrendAnalysis: React.FC = () => {
  return (
    <Paper sx={{ p: 3 }}>
      <Typography variant="h6" gutterBottom>
        Attendance & Intervention Trends
      </Typography>
      
      <Box sx={{ width: '100%', height: 400 }}>
        <ResponsiveContainer>
          <BarChart data={mockTrendData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="month" />
            <YAxis />
            <Tooltip 
              contentStyle={{ 
                backgroundColor: 'white',
                border: '1px solid #ccc',
                borderRadius: '4px'
              }}
            />
            <Legend />
            <Bar 
              dataKey="attendance" 
              fill="#8884d8" 
              name="Attendance Rate (%)"
              radius={[4, 4, 0, 0]}
            />
            <Bar 
              dataKey="interventions" 
              fill="#82ca9d" 
              name="Interventions"
              radius={[4, 4, 0, 0]}
            />
            <Bar 
              dataKey="successRate" 
              fill="#ffc658" 
              name="Success Rate (%)"
              radius={[4, 4, 0, 0]}
            />
          </BarChart>
        </ResponsiveContainer>
      </Box>
    </Paper>
  );
};